/**
 * ADO #400 — synthetic resource definitions for command-line arguments.
 *
 * Pure data (no React) so both the editor hook (useCommandLineArgs) and the
 * code generator can share one source of truth. Present only when the entry
 * flow has opted in (`flow.usesCommandLineArgs`):
 *
 *   argc → int                  (argument count)
 *   argv → char *[] (array of strings; argv[0] is the program name)
 *
 * argv's dataType deliberately does NOT end in '*' ('char*[]'), so the picker
 * treats it as an indexable array (argv[i]) rather than a scalar pointer
 * (*argv / &argv). Its elementType 'char*' drives the %s format specifier on
 * argv[i].
 */
export const COMMAND_LINE_ARG_RESOURCES = [
  {
    id: '__argc__',
    name: 'argc',
    resourceType: 'variable',
    dataType: 'int',
    isSynthetic: true,
    description: 'Command-line argument count',
  },
  {
    id: '__argv__',
    name: 'argv',
    resourceType: 'array_of_pointers',
    dataType: 'char*[]',
    elementType: 'char*',
    pointsToType: 'char',
    isSynthetic: true,
    description: 'Command-line argument vector (argv[0] is the program name)',
  },
];

/** Append argc/argv to a resource list when the entry flow opts in. */
export function withCommandLineArgs(resources, flow) {
  if (flow && flow.isEntry && flow.usesCommandLineArgs) {
    return [...(resources || []), ...COMMAND_LINE_ARG_RESOURCES];
  }
  return resources || [];
}
